import { render } from "./OpenBonusRecordView.vue?vue&type=template&id=80c695cc&scoped=true"
import script from "./OpenBonusRecordView.vue?vue&type=script&lang=js"
export * from "./OpenBonusRecordView.vue?vue&type=script&lang=js"

import "./OpenBonusRecordView.vue?vue&type=style&index=0&id=80c695cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c695cc"]])

export default __exports__